// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_28DrVNhlJ9tYUEYkclLgPh","bg":"cAQNQ6Sb6EKwBVxWei8UK","content":"_1daBr8vxHUtgUnyk5SEZja"};


/*****************
 ** WEBPACK FOOTER
 ** ../app/Components/Survey/styles.scss
 ** module id = 488
 ** module chunks = 0
 **/